import { axios } from '@delta/api-client';

const UNKNOWN_TENANT_DETAIL = '当前请求域名未绑定到有效租户';

export function isUnknownTenantError(error: unknown): boolean {
  return axios.isAxiosError(error)
    && error.response?.status === 404
    && error.response.data?.detail === UNKNOWN_TENANT_DETAIL;
}

export function isTransientTenantContextError(error: unknown): boolean {
  if (!axios.isAxiosError(error) || axios.isCancel(error)) return false;
  const status = error.response?.status;
  return status === undefined || status === 408 || status === 429 || status >= 500;
}

export function shouldRetryTenantContext(failureCount: number, error: unknown): boolean {
  return failureCount < 3 && isTransientTenantContextError(error);
}

export function tenantContextRecoveryInterval(state: { status: string; error: unknown }): number | false {
  return state.status === 'error' && isTransientTenantContextError(state.error) ? 10_000 : false;
}
